// extracted by mini-css-extract-plugin
export var cellNote = "ComparisonTable-module--cellNote--c849f";
export var check = "ComparisonTable-module--check--bd0d7";
export var competitorCell = "ComparisonTable-module--competitorCell--dc50b";
export var competitorHeader = "ComparisonTable-module--competitorHeader--6697c";
export var feature = "ComparisonTable-module--feature--17e0e";
export var featureHeader = "ComparisonTable-module--featureHeader--19864";
export var note = "ComparisonTable-module--note--deb22";
export var presetCell = "ComparisonTable-module--presetCell--7be4a";
export var presetHeader = "ComparisonTable-module--presetHeader--ab366";
export var row = "ComparisonTable-module--row--7cf11";
export var table = "ComparisonTable-module--table--ebf22";
export var tableWrapper = "ComparisonTable-module--tableWrapper--02c4f";
export var x = "ComparisonTable-module--x--57ecb";